import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Producto } from 'src/app/interfaces/producto.interface';
import { VentaService } from 'src/app/services/venta.service';
import { Info } from 'src/app/interfaces/info.interface';


@Component({
  selector: 'app-buscar',
  templateUrl: './buscar.component.html',
  styles: [
  ]
})
export class BuscarComponent implements OnInit {

  termino: string;
  listado: Producto[];
  // listadoPantalla: Producto[];
  info: Info;

  indices = {
    listadoPantalla: [],
    fila: -1,
    indice: -1,
    indexInicio: 0,
    indexFin: 10,
  };



  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public service: VentaService,
  ) { }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(params => {
      this.termino = params['termino'];

      this.productoPorNombre(this.termino);

    });

  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {

    if (event.keyCode === 27) {
      this.router.navigateByUrl('/venta');
    }
  }

  productoPorNombre(termino: string) {

    this.service.productoPorNombre(termino).subscribe( (data: Producto[]) => {

        this.listado = data;
        this.cambiarRangoListado();

    });
  }

  cambiarRangoListado() {

    if (this.listado && this.listado.length > 0) {

      this.indices.fila = -1;
      this.indices.indexInicio = this.indices.indice + 1;
      this.indices.listadoPantalla = this.listado.slice(this.indices.indexInicio, this.indices.indexFin);

    }
  }

}
